export default [
    {
        path: '/adverts',
        name: 'Adverts',
        component: () => import ('./Adverts'),
    },
    {
        path: '/adverts/create',
        name: 'AdvertsCreate',
        component: () => import ('./Create'),
    },
    {
        path: '/adverts/:id',
        name: 'Advert',
        component: () => import ('./Advert'),
    },
    {
        path: '/adverts/:id/edit',
        name: 'AdvertsEdit',
        component: () => import ('./Edit'),
    }
];